const sideSlide= new IntersectionObserver(
    (entries, sideSlide) => {
        entries.forEach((entry) => {
            if(entry.isIntersecting){
                entry.target.classList.add('slide');
                console.log("intersected");
                sideSlide.unobserve(entry.target);
            }else {
                entry.target.classList.remove('slide');
            }
        });
    }
);

//export default
export default {
bind(el) {
    el.classList.add('before-slide');
    sideSlide.observe(el);
}
}